export const translation_11_1_A = {
  en: {},
  ko: {
    v1: {
      typography_0: `마음의 자율주행`,
      typography_1: `평소 마음속에 어떤 생각과 감정이 오가는지 매 순간 온전히 알아차리며 사는 사람은 많지 않습니다. 대부분 자신에게 어떤 생각과 감정이 떠오르고 있는지 모른 채, 무의식적으로 판단하고 행동하죠. 심리학에서는 누구나 겪는 이런 일상적인 상태를 '자동 조종(Autopilot) 상태'라고 부릅니다.`,
      typography_2: `우리의 뇌는 에너지를 아끼려고 아주 뛰어난 자율주행 시스템을 가동합니다. 늘 걷는 출근길이나 양치질처럼 익숙한 상황에서 특히 유용하죠. 딴생각을 하거나 창밖을 보면서도 거침없이 목적지에 도착할 수 있으니까요.`,
      typography_3: `문제는 마음의 자율주행이 엉뚱한 곳으로 잘못 향할 때 생깁니다. 우울하고 스트레스를 받을수록 뇌는 가장 깊게 파인 부정적인 회로를 따라 질주해 버립니다. 폭우가 쏟아지는 험한 산길에서 눈을 감은 채 차가 낭떠러지로 향하도록 내버려 두는 것과 다름없습니다.`,
      typography_4: `지금 내 마음은 주로 어떤 길을 따라 자율주행하는 것 같나요?`,

      typography_5: `인지하기의 첫걸음`,
      typography_6: `이 위험천만한 자율주행을 멈추고 삶의 운전대를 다시 쥐려면 어떻게 해야 할까요? 그 첫걸음은 바로 '아, 내 마음이 지금 자율주행 모드에 빠져 있구나' 하고 깨닫는 것입니다.`,
      typography_7: `지금 마음속에서 어떤 일이 일어나는지 알아차리는 것에서부터 모든 변화가 시작됩니다. 상황을 제대로 인지해야 목적지를 바꾸고 핸들을 고쳐 잡을 수 있으니까요.`,
      typography_8: `때로는 그동안 억눌러둔 부정적인 생각과 마주쳐 괴로울지도 모릅니다. 하지만 내면의 민낯을 마주할 약간의 용기만 낸다면 진짜 변화를 끌어낼 수 있습니다.`,
      typography_9: `앞으로 여러 기법을 익히며 직면하는 것에도 익숙해지실 테니 미리 걱정하지 않으셔도 됩니다. 직면이 편해진 뒤부터는 진짜 '나'를 알아가는 기쁨을 느끼게 될 것입니다.`,

      typography_10: `생각 세어보기`,
      typography_11: `인지치료의 거장 아론 벡(Aaron Beck)은 단순하면서도 강력한 훈련법을 하나 제안했습니다. 바로 머릿속에 떠오르는 생각의 개수를 가만히 세어보는 방법입니다. 이를 통해 '인지하기'가 무엇인지 짧게 체험해 볼 수 있습니다.`,
      typography_12: `편안한 자세로 눈을 감고, 딱 60초 동안 머릿속을 스쳐 지나가는 생각들을 세어보세요. 내용이 긍정적이든 부정적이든 그와 상관 없이, 생각이 떠오를 때마다 숫자만 하나씩 더하면 됩니다. "오늘 저녁엔 뭘 먹지?" 하나, "이 훈련이 진짜 효과가 있을까?" 둘. 이런 식으로 가볍게 세어보는 겁니다.`,
      typography_13: `타이머를 맞추고 눈을 감고 시작해 보세요. 60초 동안 몇 개의 생각을 마주했나요?`,

      typography_14: `관찰하기`,
      typography_15: `아마 생각에 휩쓸려 세던 숫자를 잊어버렸을 것입니다. 바로 다시 자동 조종 상태로 돌아간 것이지요. 당연한 현상입니다. 숫자를 얼마나 많이 세었는지는 중요치 않습니다.`,
      typography_16: `지금 중요한 것은 생각을 관찰하는 태도가 무엇인지 몸소 느껴보는 것입니다. 불쑥 두려운 마음이 들어도 "두려운 생각이 하나 또 떠올랐네" 하며 생각을 바라보는 것이죠. 이것을 시작으로 나를 짓누르던 생각과 안전한 거리를 둘 수 있습니다.`,
      typography_17: `생각은 뇌에서 일어나는 일시적인 현상일 뿐입니다. 숫자를 세는 동안, 생각의 늪에 빠지지 않고 내가 생각을 바라보고 있다는 느낌을 받으셨을 겁니다. 이렇게 한 걸음 물러나 내면을 조망하는 것이 바로 '인지하기'입니다.`,
      typography_18: `방금 전 60초의 짧은 연습만으로도 무의식적인 자율주행에 이미 작은 브레이크를 건 셈입니다. 이 느낌을 기억하면서, 앞으로 이어질 두 가지 핵심 훈련법을 알아보겠습니다.`,

      typography_19: `두 가지 훈련법`,
      typography_20: `앞으로 마음 챙김 기법인 RAIN의 첫 단계, 'R-인지하기(Recognize)'를 몸에 익히기 위해 크게 두 가지 훈련을 진행할 것입니다.`,
      typography_21: `첫 번째는 '경험 분리'입니다. 복잡하게 엉킨 경험을 눈앞에 펼쳐놓고 여러 요소로 분해하는 과정입니다. 기록을 하며 연습할 겁니다.`,
      typography_22: `두 번째는 '주의 통제'입니다. 의도적으로 특정한 곳에 주의를 기울이고 유지함으로써, 자율주행 모드에 빼앗겼던 마음의 운전대를 되찾는 힘을 기릅니다. 명상을 통해 연습할 겁니다.`,
      typography_23: `기록과 명상은 겉보기엔 달라 보여도 결국 '인지하기'라는 하나의 목표를 향합니다. 일상에서 이 두 가지 훈련을 연습하며 실전에도 적용할 수 있도록 차근차근 안내해 드리겠습니다.`,
      typography_24: `마음의 자율주행을 멈출 '인지하기'를 훈련하기 위해 앞으로 다룰 두 가지 핵심 방법은 무엇일까요?`,
      typography_quiz_incorrect: `활동지를 천천히 살펴본 뒤 다시 답해보세요.`,
      typography_25: `정답은 B입니다. 마음속에 벌어지는 일들을 정확히 알아차리기 위해 부정적 경험의 꾸러미를 해체하는 '경험 분리'와 스스로 주의력을 조절해내는 '주의 통제' 훈련을 해나갈 것입니다.`,
    },
  },
};
